<template>
  <section class="not-found">
    <div class="error-art" aria-hidden="true">
      <span>4</span><i></i><span>4</span>
    </div>
    <p class="eyebrow">This debit doesn’t balance</p>
    <h1>That page went missing.</h1>
    <p class="explanation">
      The link may be outdated, but your next step is still easy.
    </p>
    <div class="actions">
      <router-link to="/" class="primary-action">See tutoring options</router-link>
      <router-link to="/contact" class="secondary-action">Book a free call ↗</router-link>
    </div>
  </section>
</template>

<style lang="scss" scoped>
.not-found {
  display: grid;
  min-height: 75vh;
  place-items: center;
  align-content: center;
  padding: 6rem 1.5rem;
  overflow: hidden;
  background:
    linear-gradient(rgba(255, 255, 255, 0.055) 1px, transparent 1px),
    linear-gradient(90deg, rgba(255, 255, 255, 0.055) 1px, transparent 1px),
    var(--ink);
  background-size: 60px 60px;
  color: white;
  text-align: center;
}

.error-art {
  display: flex;
  align-items: center;
  gap: 0.18em;
  color: var(--amber);
  font-size: clamp(8rem, 20vw, 18rem);
  font-weight: 800;
  letter-spacing: -0.1em;
  line-height: 0.7;
}

.error-art i {
  display: block;
  width: 0.48em;
  height: 0.48em;
  border: 0.08em solid var(--amber);
  border-radius: 50%;
  background: var(--blue);
  box-shadow: inset 0 0 0 0.09em var(--ink);
}

.eyebrow {
  margin: 3rem 0 0.8rem;
  color: #9eb1ff;
  font-size: 0.76rem;
  font-weight: 800;
  letter-spacing: 0.16em;
  text-transform: uppercase;
}

h1 {
  margin: 0;
  font-size: clamp(2.5rem, 6vw, 5rem);
  letter-spacing: -0.06em;
}

.explanation {
  margin: 1rem 0 0;
  color: #cbd2df;
}

.actions {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 0.8rem;
  margin-top: 2.2rem;
}

.actions a {
  padding: 0.95rem 1.15rem;
  border-radius: 999px;
  font-weight: 800;
}

.primary-action {
  background: var(--amber);
  color: var(--ink);
}

.secondary-action {
  border: 1px solid rgba(255, 255, 255, 0.22);
  color: white;
}
</style>
